import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';

import { persistedSearchReducer, cutterSearchApi } from './redux/cutterSearchAPI';
import { cutterHistoryApi } from './redux/cutterHistoryAPI';
import { appSettingsApi } from './redux/appSettingsAPI';
import { persistStore } from 'redux-persist';
import { userStateReducer } from './redux/userAuth';
import { appContextApi, appContextReducer } from './redux/appContext';
import { statsApi, statsReducer } from './redux/stats';
import { hardwareErrorsApi } from './redux/hardwareErrorsApi';
import { persistedThemePreferenceReducer } from './redux/themePreference';
import { persistedReportFilterReducer } from './redux/reportFilter';
import { persistedHelpVisibilityReducer } from './redux/helpVisibility';
import { persistedErrorsPreferenceReducer } from './redux/errorsPreference';
import { persistedReleaseNotesVisibilityReducer } from './redux/releaseNotesVisibility';



const rootReducer = combineReducers({
    userStateReducer,
    [appContextApi.reducerPath]: appContextApi.reducer,
    appContextReducer,
    [cutterSearchApi.reducerPath]: cutterSearchApi.reducer,
    [cutterHistoryApi.reducerPath]: cutterHistoryApi.reducer,
    [appSettingsApi.reducerPath]: appSettingsApi.reducer,
    persistedSearchReducer,
    [statsApi.reducerPath]: statsApi.reducer,
    statsReducer,
    [hardwareErrorsApi.reducerPath]: hardwareErrorsApi.reducer,
    persistedThemePreferenceReducer,
    persistedReportFilterReducer,
    persistedHelpVisibilityReducer,
    persistedErrorsPreferenceReducer,
    persistedReleaseNotesVisibilityReducer
});
// Store
export const store = configureStore({
    preloadedState: {

    },
    
    // Add the generated reducer as a specific top-level slice
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false })
            .concat(appContextApi.middleware)
            .concat(cutterSearchApi.middleware)
            .concat(cutterHistoryApi.middleware)
            .concat(appSettingsApi.middleware)
            .concat(statsApi.middleware)
            .concat(hardwareErrorsApi.middleware)
            // .concat(logger)
    // ,preloadedState: { 
    //    // Might retrieve initialState from a previous serialized session
    //    search: initialState,
    // }
 
    , devTools: process.env.NODE_ENV !== 'production'
    //, enhancers: {}
})


setupListeners(store.dispatch);

// STATES
export type AppStore = typeof store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const persistedStore = persistStore(store);
export default store
    


